import styled from "styled-components";

export const Sidebar = styled.nav.attrs({
  "data-testid": "content-section-nav",
} as Record<string, string>)`
  position: sticky;
  top: 0;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 0 0 240px;
  min-height: 0;
  max-height: 100%;
  overflow-y: auto;
  overscroll-behavior: contain;

  @media (max-width: 1080px) {
    position: static;
    flex-direction: row;
    flex-wrap: wrap;
    flex: 1 1 auto;
    overflow: visible;
  }
`;

export const SidebarButton = styled.button<{ $active?: boolean }>`
  display: flex;
  align-items: center;
  width: 100%;
  border: none;
  border-radius: 8px;
  background: ${({ $active }) => ($active ? "#ebf4ff" : "transparent")};
  color: #181818;
  padding: 14px 16px;
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  text-align: left;
  cursor: pointer;
  transition:
    background-color 0.2s ease,
    color 0.2s ease;

  &:hover {
    background: ${({ $active, theme }) =>
      $active ? "#ebf4ff" : theme.sidebarHeader.background2};
    color: ${({ $active }) => ($active ? "#181818" : "#005fb8")};
  }

  @media (max-width: 1080px) {
    width: auto;
  }
`;
